import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { QuestionPageContainer } from "~/OnboardingApp/components";
import { ActivateCard } from "./ActivateCard";
import { HelpModal } from "./HelpModal";
import { PageHeadings } from "./PageHeadings";

export const Body: FC = () => {
  return (
    <QuestionPageContainer maxW="unset" pt={0}>
      <PageHeadings />
      <Flex direction="column" gap={5}>
        <ActivateCard />
        <HelpModal />
      </Flex>
    </QuestionPageContainer>
  );
};
